import { AfterViewInit, Component, forwardRef, Input, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CurrencyDto } from '../../../models/CurrencyDto';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-currency-selector',
  templateUrl: './currency-selector.component.html',
  styleUrls: ['./currency-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencySelectorComponent),
      multi: true
    }
  ]
})
export class CurrencySelectorComponent implements AfterViewInit, ControlValueAccessor {

  @Input()
  currencyPairs: Array<CurrencyDto>;

  @ViewChild('cpSelect')
  ngSelect: NgSelectComponent;

  sixLetterCode: string;

  propagateChange: any = () => {};

  constructor(private readonly renderer: Renderer2) {
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.sixLetterCode = obj;
  }

  ngAfterViewInit(): void {
    this.renderer.setAttribute(this.ngSelect.searchInput.nativeElement, 'data-lpignore', 'true');
  }
}
